<template>
  <div class="container-fluid p-0">
    <div class="row mb-2 mb-xl-3">
      <div class="col-auto d-none d-sm-block">
        <h3 class="laranja h4">{{ $t('label.fichaTecnicaEspecie') }}</h3>
      </div>
    </div>
    <FichasFiltro />
  </div>
</template>

<script>
import FichasFiltro from './FichasFiltro.vue'
export default {
  name: 'Fichas',
  components: { FichasFiltro }
}
</script>
